import { createContext, useContext, useState, type ReactNode } from "react";
import { useQuery } from "@tanstack/react-query";
import { queries } from "../lib/api";
import { governanceAPI } from "../lib/governance";
function useGrantQuery() {
  const me = useQuery(queries.me());
  const identity = me.data?.subject || me.data?.email;
  return useQuery({
    queryKey: ["governance", "own", identity],
    enabled: !!identity,
    queryFn: governanceAPI.requests,
    refetchInterval: 15000,
  });
}
const OwnGrantsContext = createContext<{
  ownRequests: ReturnType<typeof useGrantQuery>;
  summarySlot: HTMLDivElement | null;
  registerSummarySlot: (element: HTMLDivElement | null) => void;
} | null>(null);
export function OwnGrantsProvider({ children }: { children: ReactNode }) {
  const ownRequests = useGrantQuery();
  const [summarySlot, registerSummarySlot] = useState<HTMLDivElement | null>(null);
  return (
    <OwnGrantsContext.Provider value={{ ownRequests, summarySlot, registerSummarySlot }}>
      {children}
    </OwnGrantsContext.Provider>
  );
}
export function useOwnGrants() {
  const state = useContext(OwnGrantsContext);
  if (!state) throw new Error("Own grants require the signed-in workspace");
  return state;
}
